import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ListSvg } from './svgs';

export const IconList: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={ListSvg} viewBox="0 0 24 24" {...props} />;
};
